<template>
  <div class="lz-field">
    <label class="lz-field-label">Manager</label>
    <b-select
      class="form-control"
      v-model="selectedManager"
      @change="managerChanged"
      :options="managers">
    </b-select>
  </div>
</template>

<script>
import Services from '../../services/main.service.vue'

export default {
  name: 'ManagerSelector',
  data() {
    return {
      selectedManager: 'def',
      managers: []
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    manager() {
      return this.FormData.approvalmanager
    }
  },
  mounted() {
    this.getManagers()
  },
  methods: {
    async getManagers() {
      const Managers = await Services.Users.getUsersByRole('manager')
      this.managers = Managers.data.content.map((manager) => {
        return {
          value: manager.uid,
          text: `${manager.firstName} ${manager.lastName}`
        }
      })
      this.managers.unshift({
        value: 'def',
        text: 'Select one...'
      })
    },
    managerChanged() {
      if (this.manager !== this.selectedManager) {
        this.$store.commit('modifyFormData', {
          key: 'approvalmanager',
          value: this.selectedManager
        })
      }
    }
  }
}
</script>
